import axios from 'axios';

const API = axios.create({
  baseURL: 'https://http--anns-backend--nwpxp46295cg.code.run/api',
  timeout: 15000,
});

// Attach admin token to every request if present
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('anns_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem('anns_admin_token')) {
      localStorage.removeItem('anns_admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default API;